var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("transition", { attrs: { name: "modal" } }, [
    _vm.openedModal
      ? _c("div", { class: ["modal", _vm.position] }, [
          _vm.closeBtn
            ? _c("div", { staticClass: "modal__header" }, [
                _c(
                  "button",
                  {
                    staticClass: "modal__close",
                    attrs: { type: "button" },
                    on: { click: _vm.close }
                  },
                  [_vm._v("Close")]
                )
              ])
            : _vm._e(),
          _c(
            "div",
            { staticClass: "modal__wrapper" },
            [_vm._t("body", [_vm._v(" form ")])],
            2
          )
        ])
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-92eec596", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-92eec596","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/_UI/BaseModal.vue
// module id = efmC
// module chunks = 13